import { render, staticRenderFns } from "./custom-tops-card.vue?vue&type=template&id=279940b5&scoped=true"
import script from "./custom-tops-card.vue?vue&type=script&lang=js"
export * from "./custom-tops-card.vue?vue&type=script&lang=js"
import style0 from "./custom-tops-card.vue?vue&type=style&index=0&id=279940b5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279940b5",
  null
  
)

export default component.exports